import React from "react";
import { Spinner } from "flowbite-react";

const AuthLoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Spinner size="xl" />
        <p className="mt-4 text-lg text-gray-600">Checking authentication...</p>
      </div>
    </div>
  );
};

export default AuthLoadingScreen;
